import { Fade, Stack, Typography, useTheme } from '@mui/material';
import { MAX_FIELD_ROW_WIDTH } from './constants';
import type { DisplayRow } from './extractionDisplay';

interface Props {
    rows: DisplayRow[];
    visible: boolean;
}

export default function OcrResultRows({ rows, visible }: Props) {
    const theme = useTheme();

    if (rows.length === 0) {
        return (
            <Fade in={visible} timeout={600}>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                    No fields were extracted from this document.
                </Typography>
            </Fade>
        );
    }

    return (
        <Stack
            spacing={1}
            sx={{
                width: MAX_FIELD_ROW_WIDTH,
                boxSizing: 'border-box',
            }}
        >
            {rows.map((row, index) => (
                <Fade
                    key={row.label}
                    in={visible}
                    timeout={500}
                    style={{ transitionDelay: `${index * 120}ms` }}
                >
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="flex-start"
                        sx={{
                            py: 0.75,
                            px: 1.25,
                            borderRadius: '4px',
                            bgcolor: 'rgba(255, 255, 255, 0.9)',
                            border: `1px solid ${theme.palette.divider}`,
                            width: '100%',
                            boxSizing: 'border-box',
                        }}
                    >
                        <Typography
                            variant="body2"
                            fontWeight={600}
                            color="text.secondary"
                            sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                        >
                            {row.label}:
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.primary"
                            sx={{
                                flex: 1,
                                minWidth: 0,
                                wordBreak: 'break-word',
                            }}
                        >
                            {row.value}
                        </Typography>
                    </Stack>
                </Fade>
            ))}
        </Stack>
    );
}
